import { Link } from '@mui/material';
import type { LinkProps as MuiLinkProps } from '@mui/material';

export type AnchorProps = MuiLinkProps;

/** Shows simple anchor link around the children component. Based on MUI Link: https://mui.com/material-ui/react-link/ */
export const Anchor = (props: AnchorProps) => <Link {...props} />;
